import React from "react";
import { useDispatch } from "react-redux";

import { refundTransaction } from "../../services/payment";
import { showAlert } from "../../store/ducks/alert";

import CloseIcon from "@material-ui/icons/Close";
import {IconButton, Button } from "@material-ui/core";

const Refund = ({ onClose, paymentUid }) => {
  const dispatch = useDispatch();

  const handleSubmit = async () => {
  
    try {
      await refundTransaction(paymentUid);
      dispatch(showAlert("success", "Transaction refunded! 🔥"));
      window.location = "/payments";
    } catch (ex) {
      dispatch(
        showAlert("error", "Error! We could not refund this transaction. 😔")
      );

    }
  };

  return (
    <div className="modal-container">
      <div className="modal-container-top">  
        <h2>Are you sure you want to refund this transaction?</h2>
        
        <IconButton onClick={onClose} >
          <CloseIcon />
        </IconButton>
      </div>
      <div>
          <h4>{paymentUid}</h4>
        </div>
      <Button 
        onClick={handleSubmit}
        variant="contained"
        color="primary"
        className="form-btn"
      >
        Yes
      </Button>
    </div>
  );
};
export default Refund;
